import { client } from "helper/apolloConfig";
import { globalVariables } from "helper/globalVariables";
import { forwardRef, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { updateDogNotesMutation } from "redux/features/dogSlice/dogGql";
import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { OutlineButton } from "shared/Components/outlineButton";
import { TextArea } from "shared/Components/textarea";
import { addNoteResolver } from "validators/UserValidation";

export const AddNoteModal = forwardRef((props, ref) => {
  const { title, dogId, onSubmit, note } = props || {};
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue("note", note);
  }, [note]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: addNoteResolver,
    defaultValues: {
      note: "",
    },
  });

  const onHandleSubmit = async (credentials) => {
    setLoading(true);
    try {
      const res = await client.mutate({
        mutation: updateDogNotesMutation,
        variables: {
          dogId,
          notes: credentials.note,
        },
      });

      if (res?.data) {
        setLoading(false);
        reset();
        ref.current?.closeModal();
        onSubmit?.();
      }
    } catch {
      setLoading(false);
    }
  };

  return (
    <Modal
      extraClass={"max-h-[400px] pt-0"}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={ref}
    >
      <div className="bg-white w-[306px] lg:w-[406px]">
        <div className="flex justify-start flex-col pb-3 sticky top-0 bg-white pt-4">
          {!!title && (
            <span className="text-lg font-semibold text-gray-900">{title}</span>
          )}
        </div>
        <form
          className="items-center flex flex-col"
          onSubmit={handleSubmit(onHandleSubmit)}
        >
          <TextArea
            register={register}
            name="note"
            placeholder={globalVariables.addNoteHere}
            errorMsg={errors.note?.message}
            rows={6}
            width="lg:w-[406px] w-[306px]"
          />
          <div className="mb-6" />
          <div className="flex flex-row">
            <OutlineButton
              onClick={() => {
                // reset();
                ref.current?.closeModal();
              }}
              width={"lg:w-[190px] w-[140px]"}
              label={globalVariables.cancel}
            />
            <div className="ml-6" />
            <Button
              width={"lg:w-[190px] w-[140px]"}
              label={globalVariables.submit}
              disabled={loading}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
});
